import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { EMPTY, of, Observable, Subject, timer } from 'rxjs';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { TipoMensagem } from '../_classes/enum/tipo_mensagem';
import { Mensagem } from '../_classes/mensagem';
import { Notificacao } from '../_classes/notificacao';
import { NotificacaoDestino } from '../_classes/notificacao-destino';
import { Retorno } from '../_classes/retorno';
import { Util } from '../_classes/util';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { MensagemService } from '../_servicos/mensagem.service';
import { MenuService } from '../_servicos/menu.service';
import { NotificacaoService } from '../_servicos/notificacao.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';

@Component({
  selector: 'app-notificacao-mostrar',
  templateUrl: './notificacao-mostrar.component.html',
  styleUrls: ['./notificacao-mostrar.component.scss'],
})
export class NotificacaoMostrarComponent implements OnInit {
  private readonly recurso: string = 'notificacao-mostrar'; //mesmo que a rota
  carregando = false;

  erros$ = new Subject<boolean>();
  dataSource: MatTableDataSource<NotificacaoDestino>;
  dataSource$: Observable<NotificacaoDestino[]>;
  notificacao: any;
  totalItens: number = 0;
  //itemAtivo = 0;
  resposta: string = '';
  respostaArray: string[] = [];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
    this._sEnv.notificacoesMostrando = this._sEnv.mobile ? true : false;
  }

  constructor(
    private _sN: NotificacaoService,
    private _sR: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private _sMsg: MensagemService,
    private _sM: MenuService,
    private router: Router,
    private _sEnv: EnvService
  ) {
    this.notificacao = new NotificacaoDestino();
  }

  ngOnInit() {
    //deixa igual para não fazer a verificação a cada 5minutos quando em celulares

    this._sEnv.notificacoesMostrando = true;

    this.atualizar();
  }

  marcarMensagem(d: NotificacaoDestino, tipo) {
    //console.log('marcarMensagem[' + tipo + ']', d);
    //I - ignorada, V - visualizada, L - lida/respondida
    let n = new NotificacaoDestino();
    n.fkServidor = Number(this._sEnv.servidor.nrMatricula);
    n.id = d.id;
    n.dsResposta = this.resposta;
    //this.dataSource.filteredData[this.itemAtivo].dsResposta = this.resposta;

    if (d && tipo) {
      this._sN.marcarComo(n, tipo).subscribe({
        next: (x: Retorno) => {
          if (x) {
            if (x.resultado == 'OK') {
              if (tipo !== 'V') {
                let m: Mensagem = new Mensagem();
                m.mensagem = x.resultado
                  ? 'Notificação "' + d?.notificacao?.dsAssunto + '" ' + tipo ==
                    'I'
                    ? 'ignorada. '
                    : 'respondida'
                  : 'Erro ao ignorar notificação "' +
                    d.notificacao.dsAssunto +
                    '"';
                m.tipo = x.resultado ? TipoMensagem.SUCESSO : TipoMensagem.ERRO;
                this._sMsg.registrarMensagem(m);

                this.verificarSeRespondeuTudoSenaoMostrarProxima();
              }
            } else {
              this.handleError(x.resultado);
            }
          } else {
            this.handleError('Erro genérico ao tentar registrar informações');
          }
        },
        error: (e: any) => {
          this.handleError(e.message);
          return EMPTY;
        },
        complete: () => {
          this.carregando = false;
        },
      });
    }
  }

  onCheckboxChange(opcao: string) {
    if (this.respostaArray.includes(opcao)) {
      // Remove o item do array de selecionados
      const index = this.respostaArray.indexOf(opcao);
      this.respostaArray.splice(index, 1);
    } else {
      // Adiciona o item ao array de selecionados
      this.respostaArray.push(opcao);
    }
    this.resposta = this.respostaArray.join(';');
    //console.log('Filhos selecionados:', this.respostaArray);
  }

  verificarSeRespondeuTudoSenaoMostrarProxima() {
    this.dataSource.filteredData.shift();
    if (this.dataSource.filteredData.length > 0) {
      this.executarAoCarregarDatasource(this.dataSource.filteredData);
    } else {
      this.navegarParaInicio();
    }
  }

  limparResposta() {
    this.resposta = '';
    this.respostaArray = [];
  }

  executarAoCarregarDatasource(x: NotificacaoDestino[]) {
    //console.log('executarAoCarregarDatasource', x);
    if (x) {
      this.dataSource = new MatTableDataSource<NotificacaoDestino>(x);
      this.totalItens = this.dataSource.filteredData.length;
      //if (this.dataSource.filteredData.length > 0) {
      this.notificacao = this.dataSource.filteredData[0];
      this.limparResposta();
      //console.log('atribuição de item', this.notificacao);
      this.marcarMensagem(this.notificacao, 'V');
      //}
      this.dataSource$ = of(x);
      this._sM.emitirMostrarMenu(false);
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  ver(n: NotificacaoDestino): void {
    this.notificacao = n;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    //console.log('a');
    if (this._sEnv?.servidor) {
      this.listar();
    } else {
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this._sEnv.servidor.idServidor,
      this._sR
    );
    // console.log('1');
    this._sN
      .listarNotificacoesMinhasNaoRespondidas(this._sEnv.servidor.nrMatricula)
      .subscribe({
        next: (x: Retorno) => {
          //console.log('2');
          if (x.resultado.length !== 0) {
            //this.itemAtivo = 0;
            this.executarAoCarregarDatasource(x.resultado);
          } else {
            this.navegarParaInicio();
          }
        },
        error: (e: any) => {
          this.handleError(e.message);
          return EMPTY;
        },
        complete: () => {
          //console.log('3');
          this.carregando = false;
        },
      });
  }
  navegarParaInicio() {
    this._sEnv.mostrarMenu = true;
    this._sM.emitirMostrarMenu(true);
    this.router.navigate(['/inicio']);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
